import React, { useState, useEffect } from "react";
import cx from "classnames";
import browser1 from "./browser-coconote-1.png";
import browser2 from "./browser-coconote-2.png";
import browser3 from "./browser-coconote-3.png";
import styles from "./Slider.module.css";

const IMAGES = [browser1, browser2, browser3];

export default function Slider() {
  const [index, setIndex] = useState(0);

  function next() {
    const newIndex = index === IMAGES.length - 1 ? 0 : index + 1;
    setIndex(newIndex);
  }

  useEffect(() => {
    const interval = setInterval(next, 5000);
    return () => clearInterval(interval);
  });

  return (
    <div className={styles.container}>
      {IMAGES.map((image, i) => {
        const active = index === i;
        return (
          <img
            key={image}
            className={cx(styles.img, { [styles.active]: active })}
            src={image}
            alt="browser"
          />
        );
      })}
    </div>
  );
}
